import React from "react";
import "./PrivacyPolicy.css";
import { BrowserRouter as Router, Link, useLocation, NavLink } from "react-router-dom";
// eslint-disable-next-line no-unused-vars

import "./PrivacyPolicy.css";


function PrivacyPolicy() {
  return (
    
    <div className="polis__privacy" >
      <div className="privacy__subtitle">
        <h2 className="privacy__title">Политика конфиденциальности</h2>
        <p>Мы используем эти данные для следующих целей:</p>
        <div>
          <ul>
            <li>Предоставление и улучшение наших услуг: Мы можем использовать полученные данные для предоставления Вам запрошенных услуг и улучшения функциональности и качества нашего веб-сайта.</li>
            <li>Коммуникация с вами: Мы можем использовать Ваши контактные данные для связи с Вами по поводу Ваших запросов, предоставления информации о наших услугах и отправки маркетинговых сообщений.</li>
          </ul>
        </div>
      </div>

      <div className="privacy__subtitle">
        <p>Разглашение персональных данных:</p>
        <div>
          <ul>
            <li>Законодательные требования: Мы можем раскрывать Вашу информацию, если это необходимо для соблюдения законодательства или судебного решения.</li>
            <li>Подрядчики и агенты: Мы можем использовать сторонних поставщиков услуг для обработки Ваших данных от нашего имени, например, для хранения данных или обработки платежей. В этом случае мы требуем, чтобы эти стороны обеспечивали адекватную защиту Ваших персональных данных.</li>
          </ul>
        </div>
      </div>

      <div className="privacy__subtitle">
        <p>Хранение данных:</p>
        <p>Мы будем хранить Ваши персональные данные только на время, необходимое для достижения целей, описанных в настоящей политике конфиденциальности, или до тех пор, пока мы не получим Ваше согласие на дальнейшее хранение.</p>
      </div>

      <div className="privacy__subtitle">
        <p>Защита данных:</p>
        <p>Мы принимаем все разумные меры по обеспечению безопасности Ваших персональных данных и защите их от потери, несанкционированного доступа, использования, модификации или раскрытия.</p>
      </div>

      <div className="privacy__subtitle">
        <p>Ваши права:</p>
        <p>У Вас есть право на доступ к вашим персональным данным, и Вы можете запросить копию, исправление или удаление этих данных. Если Вы хотите воспользоваться своими правами или у Вас есть вопросы о нашей политике конфиденциальности, пожалуйста, свяжитесь с нами.</p>
      </div>

      <div className="privacy__subtitle">
        <p>Изменения в политике конфиденциальности:</p>
        <p>Мы можем время от времени вносить изменения в нашу политику конфиденциальности. В случае существенных изменений мы уведомим Вас путем размещения обновленной версии нашей политики конфиденциальности на нашем веб-сайте. Это лишь общий пример политики конфиденциальности, и Вам следует учесть своеобразия Вашей организации или веб-сайта и приспособить политику к вашим потребностям и правовым требованиям.</p>
      </div>
      <div className="back__btn"> 
      <ul>
      <li><Link to="/">На главную</Link>
      </li>
      </ul>
      </div>
    </div>

  );
}

export default PrivacyPolicy;